import { deliveriesListTags } from "../../../../config/tagList";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import { DeliveryCount } from "../../../../models/deliveryCount";
import YourDeliveriesCard from "../yourDeliveriesCard/YourDeliveriesCard";

interface YourDeliveriesCardsProps {
  deliveryCount: DeliveryCount[];
  setDeliveryCount: (count: DeliveryCount) => void;
}

const YourDeliveriesCards = (props: YourDeliveriesCardsProps) => {
  const { navigateToDeliveriesWithTag } = useNavigateTo();

  const { deliveryCount, setDeliveryCount } = props;

  const allCards = () => {
    return deliveriesListTags.map((tag, index) => {
      return (
        <div
          key={index}
          className={`section-container-card-row-item ${tag.name}-color`}
          onClick={() => navigateToDeliveriesWithTag(tag.name)}
        >
          <YourDeliveriesCard
            tag={tag}
            count={
              deliveryCount.find((count) => count.key === tag.name)?.value || 0
            }
            setDeliveryCount={setDeliveryCount}
          />
        </div>
      );
    });
  };

  const firstRowCards = allCards().slice(0, 2);
  const secondRowCards = allCards().slice(2, 4);

  return (
    <>
      <div className="section-container-card-row">{firstRowCards}</div>
      <div className="section-container-card-row">{secondRowCards}</div>
    </>
  );
};

export default YourDeliveriesCards;
